import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	releaseDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	releaseDate: {
		id: 'project-directories.versions.release-version-modal.content.release-date.release-date',
		defaultMessage: 'Release date',
		description: '',
	},
});
export default messages;
